import { useContext, useEffect, useState } from "react";
import productService from "../services/productService";
import ProductList from "../components/ProductList";
import CustomSpinner from "../components/CustomSpinner";
import UserContext from "../context/UserContext";

export default function Products() {

  const { user } = useContext(UserContext)

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user)
      window.location.href = "/";
  }, [user]);

  useEffect(() => {
    setLoading(true);
    productService.getAll().then((res) => {
      setProducts(res.data);
    }).catch((err) => {
      alert("Error fetching products:", err);
    })
      .finally(() => {
        setLoading(false);
      });;
  }, []);

  const refresh = () => {
    setLoading(true);
    productService.getAll().then((res) => {
      setProducts(res.data);
    }).catch((err) => {
      alert("Error fetching products:", err);
    })
      .finally(() => {
        setLoading(false);
      });;
  };

  return (
    <>
      {
        loading && (<CustomSpinner />)
      }
      <div className="app-shell banner-1">
          <div className="app-panel text-center">
            <div className="mb-6 text-left"><h1 className="text-2xl font-semibold">Almacén de productos</h1></div>
            <div>
              <ProductList products={products} onChange={refresh} />
            </div>
          </div>
      </div>
    </>
  );
}
